<template>
  <form @submit.prevent="submit">
    <fg-input label="Name" type="text" v-model="cause.name" :error="valErrors['name'] ? valErrors['name'][0] : null" />
    <div>
      <label>Lagerstand Änderung</label>
      <div class="form-group has-label">
        <div>
          <l-radio class="pr-3" v-model="cause.direction" inline label="1">Einbuchung</l-radio>
          <l-radio class="pr-3"  v-model="cause.direction" inline label="-1">Ausbuchung</l-radio>
          <l-radio class="pr-3"  v-model="cause.direction" inline label="0">Keine Änderung</l-radio>
        </div>
      </div>
    </div>
    <div>
      <label>Produktpreis erfassen</label>
      <div class="form-group">
        <div >
          <l-radio v-model="cause.has_price" inline label="1">Ja</l-radio>
          <l-radio v-model="cause.has_price" inline label="0">Nein</l-radio>
        </div>
      </div>
    </div>
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
import { Radio as LRadio } from 'src/components'

export default {
  props: ['valErrors', 'initCause', 'submitText'],
  components: { LRadio },
  data() {
    return {
      cause: this.initCause
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.cause)
    }
  }
}
</script>

<style></style>
